/**
 * 平台模块（modules/ 平台级页面 + components/ 公共业务组件）英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 * 覆盖范围：
 * - src/views/modules/message/   系统消息、消息模板
 * - src/views/modules/monitor/   服务器监控（Tomcat/JVM/Redis/磁盘/HTTP 追踪）
 * - src/views/modules/oss/       OSS 文件列表
 * - src/views/components/        JSelectBizComponent 选择组件、JSelectFlowpathCheck 流程选择
 * 术语约定：系统消息=System Message，消息模板=Message Template，发送=Send，
 *          服务器监控=Server Monitor，缓存=Cache，文件=File，上传=Upload，选择组件=Select Component
 */
export default {
  'CPU 数量': 'CPU Count',
  'FullGC 时, 老年代的内存空间': 'Memory of old generation during FullGC',
  'GC 时, 老年代的最大内存空间': 'Max memory of old generation during GC',
  'GC 时, 老年代分配的内存空间': 'Memory allocated to old generation during GC',
  'GC 时, 年轻代分配的内存空间': 'Memory allocated to young generation during GC',
  'JVM 当前活跃线程数量': 'JVM Live Thread Count',
  'JVM 峰值线程数量': 'JVM Peak Thread Count',
  'JVM 缓冲区已用内存': 'JVM Buffer Memory Used',
  'JVM 可用内存': 'JVM Committed Memory',
  'JVM 守护线程数量': 'JVM Daemon Thread Count',
  'JVM 未加载 Class 数量': 'JVM Unloaded Class Count',
  'JVM 已加载 Class 数量': 'JVM Loaded Class Count',
  'JVM 已用内存': 'JVM Used Memory',
  'JVM 最大内存': 'JVM Max Memory',
  'MINIO文件上传': 'MINIO File Upload',
  'OSS文件上传': 'OSS File Upload',
  'Radis 内存实时占用情况（KB）': 'Radis Memory Real-time Usage (KB)',
  'Radis Key 实时数量（个）': 'Radis Keys Real-time Count',
  'Redis终端': 'Redis Terminal',
  'Redis 详细信息': 'Redis Details',
  'YYYY年MM月DD日 HH时mm分ss秒': 'YYYY-MM-DD HH:mm:ss',
  '备注': 'Remark',
  '编辑': 'Edit',
  '参数': 'Parameter',
  '操作': 'Action',
  '测试数据': 'Test Data',
  '查询': 'Query',
  '超过session 最大配置后，拒绝的 session 个数': 'Rejected sessions after exceeding the max session config',
  '次': 'times',
  '磁盘监控': 'Disk Monitoring',
  '当前缓冲区数量': 'Current Buffer Count',
  '当前应用 CPU 使用率': 'Current Application CPU Usage',
  '当前值': 'Current Value',
  '导出': 'Export',
  '导入': 'Import',
  '短信': 'SMS',
  '发送测试': 'Send Test',
  '发送次数': 'Send Count',
  '发送的字节数': 'Bytes Sent',
  '发送方式': 'Send Method',
  '发送内容': 'Message Content',
  '发送失败原因': 'Send Failure Reason',
  '发送时间': 'Send Time',
  '发送所需参数': 'Send Parameters',
  '发送状态': 'Send Status',
  '个': 'pcs',
  '更多': 'More',
  '共追踪到 {count} 条近期HTTP请求记录': 'Tracked {count} recent HTTP request records',
  '共{total}条': 'Total {total} records',
  '挂起': 'Suspend',
  '关闭': 'Close',
  '核': 'cores',
  '获取 Redis 信息失败': 'Failed to get Redis info',
  '获取HTTP信息失败': 'Failed to get HTTP info',
  '获取JVM信息失败': 'Failed to get JVM info',
  '获取Tomcat信息失败': 'Failed to get Tomcat info',
  '获取服务器信息失败': 'Failed to get server info',
  '激活': 'Activate',
  '接收人': 'Receiver',
  '立即更新': 'Update Now',
  '立即刷新': 'Refresh Now',
  '流程标识key': 'Process Key',
  '流程定义': 'Process Definition',
  '流程分类': 'Process Category',
  '流程名称': 'Process Name',
  '秒': 's',
  '描述': 'Description',
  '模板CODE': 'Template Code',
  '模板标题': 'Template Title',
  '模板类型': 'Template Type',
  '模板内容': 'Template Content',
  '内存（KB）': 'Memory (KB)',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '请求URL': 'Request URL',
  '请求方法': 'Request Method',
  '请求耗时': 'Time Taken',
  '请求时间': 'Request Time',
  '请上传图片': 'Please upload an image',
  '请上传文件': 'Please upload a file',
  '请输入': 'Please enter',
  '请输入发送内容': 'Please enter message content',
  '请输入发送所需参数Json格式': 'Please enter send parameters (JSON format)',
  '请输入接收人': 'Please enter receiver',
  '请输入json格式测试数据': 'Please enter test data (JSON format)',
  '请输入模板CODE': 'Please enter template code',
  '请输入模板CODE!': 'Please enter the template code!',
  '请输入模板编码': 'Please enter template code',
  '请输入模板标题': 'Please enter template title',
  '请输入模板标题!': 'Please enter the template title!',
  '请输入模板类型': 'Please enter template type',
  '请输入模板类型!': 'Please enter the template type!',
  '请输入模板内容': 'Please enter template content',
  '请输入文件地址': 'Please enter file URL',
  '请输入文件名称': 'Please enter file name',
  '请输入消息标题': 'Please enter message title',
  '请输入消息接收方': 'Please enter message receiver',
  '请选择': 'Please select',
  '请选择发送方式': 'Please select send method',
  '请选择发送状态': 'Please select send status',
  '请选择模板类型': 'Please select template type',
  '请选择消息类型': 'Please select message type',
  '取消': 'Cancel',
  '全局 request 请求次数': 'Global Request Count',
  '全局 request 请求总耗时': 'Total Global Request Duration',
  '确定删除吗?': 'Are you sure you want to delete?',
  '确认删除': 'Confirm Deletion',
  'request 请求最长耗时': 'Max Request Duration',
  'servlet 请求总耗时': 'Total Servlet Request Duration',
  'servlet 请求最长耗时': 'Max Servlet Request Duration',
  'servlet 总请求次数': 'Total Servlet Request Count',
  '删除': 'Delete',
  '上次更新时间': 'Last Updated At',
  '是否删除选中文件?': 'Are you sure to delete the selected file(s)?',
  '收起': 'Collapse',
  '数量（个）': 'Count',
  '提交': 'Submit',
  'tomcat 当前活跃 session 数': 'Tomcat Active Sessions',
  'tomcat 当前线程数（包括守护线程）': 'Tomcat Current Threads (including daemon threads)',
  'tomcat 活跃 session 数峰值': 'Tomcat Max Active Sessions',
  'tomcat 配置的线程最大数': 'Tomcat Configured Max Threads',
  'tomcat 已创建 session 数': 'Tomcat Created Sessions',
  'tomcat 已过期 session 数': 'Tomcat Expired Sessions',
  '微信': 'WeChat',
  '文件地址': 'File URL',
  '文件列表': 'File List',
  '文件名称': 'File Name',
  '系统': 'System',
  '系统 CPU 使用率': 'System CPU Usage',
  '系统启动以来GC 次数': 'GC count since startup',
  '系统启动以来GC 总耗时': 'Total GC time since startup',
  '详情': 'Details',
  '响应状态': 'Response Status',
  '消息': 'Message',
  '消息标题': 'Message Title',
  '消息管理页面': 'System Message Management Page',
  '消息接收方': 'Message Receiver',
  '消息类型': 'Message Type',
  '消息模板': 'Message Template',
  '消息模板管理页面': 'Message Template Management Page',
  '新增': 'Add',
  '选择': 'Select',
  '已选择 {count} 项': '{count} items selected',
  '应用启动时间点': 'Application Start Time',
  '应用已运行时间': 'Application Uptime',
  '邮件': 'Email',
  '预览': 'Preview',
  '展开': 'Expand',
  '重置': 'Reset',
  '状态': 'Status',
  '{name} 上传成功!': '{name} uploaded successfully!',
}
